import { SelectChangeEvent, MenuItem, Select, Typography, Stack, Box } from '@mui/material';
import { ImportedPayorderDto } from '@sr/dto';
import { LinkToInvoice } from 'entities/client-invoices-list/ui/link-to-invoice';
import PriceSpan from 'shared/ui/price-span';
import { formatDate } from 'utils/date-format-helpers';


const AvailableInvoiceOption = (inv: {id: number, title: string, date: Date, amount: number}) => {
  return (
    <Stack direction={'row'} gap={1}>
      <Box>
        <LinkToInvoice
          invoice={{
            id: inv.id,
            invoiceNumber: inv.title
          }}
        />

      </Box>
      <Typography>
        <b>от</b> {formatDate(inv.date)}
      </Typography>
      <Typography>
          (<PriceSpan size="small" price={inv.amount} zeroAsDash />)
      </Typography>
    </Stack>
  );
};

export const InvoiceCellContent = ({ importedPayorder, onChange, readonly }: {
  importedPayorder: ImportedPayorderDto,
  readonly: boolean,
  onChange: (newValue: number | null) => void
}) => {
  const availableInvoices = importedPayorder.availableOptions.invoices;
  const duplicateInvoices = importedPayorder.duplicate?.invoices || [];

  if (availableInvoices.length === 0 && duplicateInvoices.length === 0)
    return (<></>);
  const selectedInvoiceId = importedPayorder.importProps.selectedInvoiceId;
  const selectedInvoice = importedPayorder.availableOptions.invoices.find(x => x.id === selectedInvoiceId);

  if (importedPayorder.invalidReasons?.hasDuplicate && duplicateInvoices.length > 0) {
    return (
      <>
        {duplicateInvoices.map(inv => (
          <LinkToInvoice key={inv.id} invoice={{
            id: inv.id,
            invoiceNumber: inv.invoiceNumber
          }} />
        ))}
      </>
    );
  }
  
  const value = importedPayorder.importProps.selectedInvoiceId || '';
  
  return (
    <Select
      size='small'
      value={value.toString()}
      renderValue={(__selected) => selectedInvoice?.title!}
      onChange={(e: SelectChangeEvent) => onChange(e.target.value === '' ? null : Number(e.target.value))}
    >
      {importedPayorder.availableOptions.invoices.map((inv) =>
        <MenuItem key={inv.id} value={inv.id}><AvailableInvoiceOption {...inv}/></MenuItem>
      )}
    </Select>
  );
};
